import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { Nav, Form } from 'react-bootstrap';

import NavBarWithToggle from './NavBarWithToggle';
import LoginModal from '../modals/LoginModal';

class GuestNavBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: typeof props.error === 'string',
      showToggle: false,
    };
    this.showLoginModal = this.showLoginModal.bind(this);
    this.hideLoginModal = this.hideLoginModal.bind(this);
    this.onSwitchToggle = this.onSwitchToggle.bind(this);
  }

  onSwitchToggle() {
    this.setState((before) => ({ showToggle: !before.showToggle }));
  }

  showLoginModal() {
    this.onSwitchToggle();
    this.setState({ showModal: true });
  }

  hideLoginModal() {
    this.setState({ showModal: false });
  }

  render() {
    const { showModal, showToggle } = this.state;
    const { onLogin, error } = this.props;

    return (
      <NavBarWithToggle
        showToggle={showToggle}
        onSwitchToggle={this.onSwitchToggle}
      >
        <Nav className="mr-auto">
          <LinkContainer exact to="/">
            <Nav.Link onClick={this.onSwitchToggle}>Home</Nav.Link>
          </LinkContainer>
          <Nav.Link onClick={this.showLoginModal}>Login</Nav.Link>
        </Nav>
        <Form inline>
          <LoginModal
            show={showModal}
            onHide={this.hideLoginModal}
            onLogin={onLogin}
            error={error}
          />
        </Form>
      </NavBarWithToggle>
    );
  }
}

GuestNavBar.propTypes = {
  onLogin: PropTypes.func.isRequired,
  error: PropTypes.string,
};

GuestNavBar.defaultProps = {
  error: undefined,
};

export default GuestNavBar;
